import React, {useState, useRef, Fragment} from 'react';
import Autocomplete from 'react-autocomplete';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';

//
export default function Autocomplete_component(props){
  const[value, setValue]=useState('');
  const[options, setOptions]=useState([]);
  let items=[];
  if(props.select_data!=undefined){for(let i of props.select_data){if(props.value==undefined || props.value=='' || i.toLowerCase().includes(props.value.toLowerCase())){items.push({label:i});}}}
  else{for(let i of options){items.push({label:i.name, id:i.id});}}


  let searchTimeout=useRef();
  function onChange(e, search=true){
    setValue(e.target.value);
    if(props.onChange!=undefined){props.onChange(e.target.value);}
    if(search!='block' && props.search_url!=undefined){
      axios.get(props.search_url+e.target.value).then((response)=>{setOptions(response.data);});
    }
  }
      return(
          <Autocomplete
          getItemValue={(item) => item.label}
          items={items}
          renderInput={(pprops)=>{
            return(<TextField {...pprops}
              onKeyDown={(e)=>{
                if(e.key=='Enter'){
                  e.preventDefault();
                  e.stopPropagation();
                }
              }}
              error={props.error} style={{maxWidth:'400px'}} variant='outlined' size='small' label={props.title}/>)
          }}
          renderItem={(item, isHighlighted) =>
            <div style={{ background: isHighlighted ? 'lightgray' : 'white' }}>
              {item.label}
            </div>
          }
          value={(props.value==undefined)?value:props.value}
          onChange={onChange}
          onSelect={(e)=>{onChange({target:{value:e}}, 'block'); let x; for(let o of options){if(o.name==e){x=o; break;}} if(props.onSelect!=undefined){props.onSelect(x);}}}
          InputProps={{title:props.title}}
          menuStyle={{
            borderRadius: '3px',
            boxShadow: '0 2px 12px rgba(0, 0, 0, 0.1)',
            background: 'rgba(255, 255, 255, 1)',
            padding: '10px',
            lineHeight:'40px',
            fontSize: '1rem',
            fontFamily:'"Roboto", "Helvetica", "Arial", sans-serif',
            position: 'fixed',
            overflow: 'auto',
            maxHeight: '50%',
            zIndex:'100000',
            cursor:'pointer'
          }}
        />
      )
  }
